import React, { createContext, useContext, useMemo, useState } from 'react';

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

const parsePriceToCents = (priceString) => {
  if (typeof priceString === 'number') return Math.round(priceString * 100);
  const cleaned = String(priceString).replace(/[^0-9.]/g, '');
  const cents = Math.round(parseFloat(cleaned || '0') * 100);
  return Number.isFinite(cents) ? cents : 0;
};

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState([]);

  const addItem = (product, quantity = 1) => {
    const id = product.id;
    const count = Math.max(1, Number(quantity) || 1);
    const unitAmount = parsePriceToCents(product.price);
    setItems((prev) => {
      const existing = prev.find((p) => p.id === id);
      if (existing) {
        return prev.map((p) => (p.id === id ? { ...p, quantity: p.quantity + count } : p));
      }
      return [...prev, { id, name: product.description || product.name, unitAmount, quantity: count }];
    });
  };

  const removeItem = (id) => setItems((prev) => prev.filter((p) => p.id !== id));

  const updateQty = (id, quantity) =>
    setItems((prev) => prev.map((p) => (p.id === id ? { ...p, quantity: Math.max(1, quantity) } : p)));

  const clearCart = () => setItems([]);

  const totalCents = useMemo(() => items.reduce((sum, i) => sum + i.unitAmount * i.quantity, 0), [items]);

  const value = {
    items,
    addItem,
    removeItem,
    updateQty,
    clearCart,
    totalCents,
  };

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};

export default CartContext;
